module.exports = __webpack_public_path__ + "d42f97d6.svg";